import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaPlane,
  FaShip,
  FaCar,
  FaPassport,
  FaHandshake,
  FaMapMarkedAlt,
  FaArrowRight,
} from "react-icons/fa";
import "../Vender/css/MultipleServices.css";

const MultipleServices = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  // Exact data requested
  const services = [
    {
      id: 1,
      title: "Cab",
      desc: "Cab services offered by our travel agencies facilitate convenient and reliable transportation options for travelers within destinations.",
      icon: <FaCar />,
      color: "#f59e0b", // Amber
      tag: "Transfer",
      image: "/assets/images/Cab.png",
    },
    {
      id: 3,
      title: "Flight",
      desc: "Flight services provided by our travel agencies encompass the booking and arrangement of air travel for individuals or groups.",
      icon: <FaPlane />,
      color: "#3b82f6", // Blue
      tag: "Global",
      image: "/assets/images/Flight.png",
    },
    {
      id: 4,
      title: "Visa",
      desc: "Visa services offered by our travel agencies facilitate the process of obtaining visas for international travel.",
      icon: <FaPassport />,
      color: "#ef4444", // Red
      tag: "Essential",
      image: "/assets/images/Visa.png",
    },
    {
      id: 5,
      title: "Personal Relationship",
      desc: "Personal relationship services offered by travel agencies enhance the client-agent relationship.",
      icon: <FaHandshake />,
      color: "#ec4899", // Pink
      tag: "Dedicated",
      image: "/assets/images/Personal relationship.png",
    },
    {
      id: 6,
      title: "Guide",
      desc: "Local guide assistant services provided by our travel agencies enhance travelers' experiences by offering personalized and knowledgeable support during their trips.",
      icon: <FaMapMarkedAlt />,
      color: "#10b981", // Emerald
      tag: "Local Support",
      image: "/assets/images/Guide.png",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`services-section ${isVisible ? "animate-active" : ""}`}
      ref={sectionRef}
    >
      {/* Background Decor */}
      <div className="svc-bg-layer">
        <div className="svc-blob blob-1"></div>
        <div className="svc-blob blob-2"></div>
        <div className="svc-grid-pattern"></div>
      </div>

      <div className="svc-container">
        {/* Header */}
        <header className="svc-header">
          <div className="svc-badge">Our Expertise</div>
          <h2 className="svc-title">
            Comprehensive <span className="svc-highlight">Travel Services</span>
          </h2>
          <p className="svc-subtitle">
            We provide a complete ecosystem of services to ensure your journey
            is seamless from start to finish.
          </p>
        </header>

        {/* Services Grid */}
        <div className="svc-grid">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="svc-card"
              style={{
                "--accent": service.color,
                "--delay": `${index * 0.1}s`,
              }}
            >
              <div className="svc-card-border"></div>

              <div className="svc-card-inner">
                <div className="svc-image-container">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="svc-service-image"
                  />
                  <div className="svc-icon-overlay">
                    <div className="svc-icon">{service.icon}</div>
                  </div>
                </div>

                <div className="svc-content">
                  <div className="svc-top-row">
                    <span className="svc-tag">{service.tag}</span>
                    <div className="svc-arrow">
                      <FaArrowRight />
                    </div>
                  </div>

                  <h3 className="svc-card-title">{service.title}</h3>
                  <p className="svc-card-desc">{service.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Bottom Banner */}
        <div className="svc-banner">
          <div className="svc-banner-content">
            <h3>Ready to plan your trip?</h3>
            <p>Let us handle the details while you enjoy the journey.</p>
          </div>
          <button className="svc-contact-btn" onClick={handleContactClick}>
            Contact Us Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default MultipleServices;
